import { useState } from "react";
import { toast } from "components/ui/use-toast";
import { Copy, Check } from "lucide-react";

interface CopyableCellProps {
  value: string;
  label?: string;
  className?: string;
}

export function CopyableCell({ value, label = "NSU", className = "" }: CopyableCellProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast({
        description: `${label} copiado com sucesso!`,
        duration: 2000,
      });

      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast({
        description: `Erro ao copiar ${label}`,
        variant: "destructive",
        duration: 2000,
      });
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`flex items-center gap-2 hover:bg-gray-100 px-2 py-1 rounded transition-colors cursor-pointer ${className}`}
      title={`Clique para copiar ${label}`}
    >
      <span className="font-mono text-sm">{value || "-"}</span>
      {copied ? (
        <Check className="w-4 h-4 text-green-500" />
      ) : (
        <Copy className="w-4 h-4 text-gray-400" />
      )}
    </button>
  );
}